function appLoggedIn(
// eslint-disable-next-line no-unused-vars
originalMethod, context) {
    const methodName = context.name;
    function replacementMethod(...args) {
        if (!this.authenticated) {
            throw new Error(`auth is currently in app-mode, but no idToken is supplied. Unable to call auth.${methodName}()`);
        }
        return originalMethod.call(this, ...args);
    }
    return replacementMethod;
}
export default appLoggedIn;
